/* Endpoint */
const isLocalHost = Boolean(
    window.location.hostname === "localhost" ||
    window.location.hostame === "[::1]" ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

/* EXPORTS */
const API_URL = isLocalHost ? "http://localhost:5000" : "https://data.artmoram.com";
export {API_URL}; 
